import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_138_purchase: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Purchase",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            style: {
              direction: FlexDirection.ROW,
            },
            childComponents: [
              {
                componentType: ComponentType.BUTTON,
                name: "Purchase with order",
                onPressAction: "navigate_140",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 12,
                  borderRadius: 8,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "Purchase without order",
                onPressAction: "navigate_139",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 12,
                  borderRadius: 8,
                },
              },
            ],
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "purchase_no",
            Name: "purchase_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "PDF",
                  Settings: "purchase_pdf_view",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "purchase_summary",
              TableName: "purchase",
              DisplayName: "purchase",
              View: "view_purchase_summary",
              Filter:
                "view_purchase_summary.soft_delete=0 order by view_purchase_summary.created_at desc",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Purchase date",
                  IsMandatory: false,
                  BindValue: "txt_Purchase_date",
                  Json_Attribute: "purchase_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Purchase order No.",
                  BindValue: "txt_pr_ord_no",
                  Json_Attribute: "purchase_order_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Purchase No.",
                  BindValue: "txt_prno",
                  Json_Attribute: "purchase_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Ref No.",
                  BindValue: "txt_Refno",
                  Json_Attribute: "vendor_refno",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor name",
                  BindValue: "supplier",
                  Json_Attribute: "suppliername",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Gross amount",
                  BindValue: "txt_gross_amt",
                  Json_Attribute: "gross_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "VAT amount",
                  BindValue: "txt_vat_amt",
                  Json_Attribute: "vat_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Discount",
                  BindValue: "txt_discount",
                  Json_Attribute: "net_discount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Net amount",
                  BindValue: "txt_net_amt",
                  Json_Attribute: "net_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Round off",
                  BindValue: "txt_round_odd",
                  Json_Attribute: "round_off_amt",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "created_by",
                  Json_Attribute: "created_by",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "P.O",
                  BindValue: "po_attachment",
                  Json_Attribute: "po_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Supplier invoice",
                  BindValue: "supplier_invoice_attachment",
                  Json_Attribute: "supplier_invoice_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Others attachment",
                  BindValue: "Others_attachment",
                  Json_Attribute: "Others_attachment",
                  componentType: ComponentType.FILES,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
